import { useDevice } from '@contexts/device';
import { formatArrayToString } from '@utils/utils';
import { RecommendedToursViewModel } from '@api/v3';

import { ContainerTour, ContainerTourMobile, Title } from '../styled';
import CarouselCard from './carousel-tour-recommendations';

const TourRecommendations = ({
  isExpedia,
  tourRecommendations,
  date,
  setIsRedirecting,
}: {
  isExpedia: boolean;
  tourRecommendations: RecommendedToursViewModel;
  date: string | string[] | undefined;
  setIsRedirecting?: (value: boolean) => void;
}) => {
  const { isDesktop } = useDevice();
  return isDesktop ? (
    <ContainerTour>
      <Title fontSize={30}>Beğenebileceğiniz Diğer Turlar</Title>
      <CarouselCard
        setIsRedirecting={setIsRedirecting}
        isExpedia={isExpedia}
        earliestDepartureDate={formatArrayToString(date || '')}
        data={tourRecommendations?.data || []}
      />
    </ContainerTour>
  ) : (
    <ContainerTourMobile>
      <Title margin={18} fontSize={20}>
        Beğenebileceğiniz Diğer Turlar
      </Title>
      <CarouselCard
        setIsRedirecting={setIsRedirecting}
        isExpedia={isExpedia}
        earliestDepartureDate={formatArrayToString(date || '')}
        data={tourRecommendations?.data || []}
      />
    </ContainerTourMobile>
  );
};

export default TourRecommendations;
